import { ImageIcon } from "lucide-react";

import { prop, define, hasKeyDeep, parseTextAlign } from "@/components/builder/utils";

import Placeholder from "../utils/Placeholder";

import BasePreview from "./base";

const getImageAlign = imageAlign => parseTextAlign(imageAlign)

function ImageContainer({ props = {}, imageAlign, children }) {
  return <div className={`w-full h-full ${getImageAlign(imageAlign || props.properties?.imageAlign)}`}>
    {children}
  </div>
}

function ImagePreview({ ...props }) {
  if (!hasKeyDeep(props, 'src')) {
    return <BasePreview>
      <div className="w-full h-full flex justify-center items-center">
        <div className="w-auto">
          <Placeholder size="h-auto" content={<>
            <ImageIcon size={100} className="w-full h-full text-gray-400" />
          </>} />
        </div>
      </div>
    </BasePreview>
  }

  return <ImageContainer props={props}>
    <BasePreview {...props}>
      <img />
    </BasePreview>
  </ImageContainer>
}

function ImageHTML({ attributes: { src, ...attributes }, imageAlign, optimization }) {
  const { width, height } = optimization || {};
  const optimizationOptions = []
  if (width) {
    optimizationOptions.push(`width=${width}`)
  }
  if (height) {
    optimizationOptions.push(`height=${height}`)
  }

  optimizationOptions.unshift(`url='${src}'`)
  src = `{{imageUrl ${optimizationOptions.join(' ')}}}`

  return <ImageContainer imageAlign={imageAlign} >
    <img src={src} {...attributes} />
  </ImageContainer>
}

export default define('image', ImagePreview, ImageHTML)
  .palete(<ImageIcon size={16} />, 'Image', 'Content')
  .property(prop.stylePattern())
  .property(prop.predefined.customClass())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.image())
  .property(prop.predefined.attributes().props({ hiddenAttributes: ['src', 'alt', 'name'] }))
  .property(prop.text(<>Optimized <br /> Width (px) </>, 'optimization.width')
    .category('standard')
    .ignoreDevice(true)
    .own()
    .props({ type: 'number' }))
  .property(prop.text(<>Optimized <br /> Height (px) </>, 'optimization.height')
    .category('standard')
    .ignoreDevice(true)
    .own()
    .props({ type: 'number' }))
  .defaultProps({
    size: {
      width: 'w-auto',
      height: 'h-auto',
    },
    imageAlign: {
      horizontal: 'center',
      vertical: 'middle',
    },
  })
  .build()
